import type { PayloadAction } from '@reduxjs/toolkit';

import type { NavigationStateStore } from '../types';
import { pruneStaleNavigationState } from './pruneStale';

export const updateState = (state: NavigationStateStore, { payload }: PayloadAction<{ key: string; data: Record<string, unknown> }>) => {
  const currentData = state[payload.key]?.data as Record<string, unknown>;

  pruneStaleNavigationState(state);

  state[payload.key] = {
    data: {
      ...currentData,
      ...payload.data,
    },
    timestamp: Date.now(),
  };
};
